import { render, staticRenderFns } from "./reason-requests-list.pug?vue&type=template&id=49b4056a&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./reason-requests-list.scss?vue&type=style&index=0&id=49b4056a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b4056a",
  null
  
)

export default component.exports